import _ from "lodash";

export const saveTableData = ({
  newValue,
  onSave,
  onUpdate,
}: {
  newValue: any;
  onSave: ({ newValue }: { newValue: any }) => Promise<any> | void;
  onUpdate: ({ message }: { message?: string }) => void;
}) => {
  const saveResult = onSave({
    newValue: newValue.map((row: any) => _.omit(row, "key")),
  });

  if (typeof saveResult?.then === "function") {
    saveResult.then(() => {
      onUpdate({});
    });
  } else {
    onUpdate({});
  }
};
